import styled from 'styled-components';
import { IThemeProvider } from '../../../../../../../../styles/theme';

export const Row = styled.tr`
  padding: 0 25px;
  display: grid;
  grid-template-columns: 5fr 1fr 1fr 8fr 1fr;
  min-height: 60px;
  ${({ theme }) => `
    background: ${theme.colors.neutral.primary[0]};
    border-bottom: 1px solid ${theme.colors.neutral.primary[10]};
  `}
  &:last-child {
    border-radius: 0 0 8px 8px;

    & > span {
      border-bottom: none;
    }
  }
`;

export const Cell = styled.tr<IThemeProvider>`
  letter-spacing: 0.04px;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;

  &:nth-child(2) {
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    margin-left: 1rem;
    margin-right: 1.5rem;
  }

  &:nth-child(4) {
    width: 100%;
    margin-left: 2.5rem;
  }

  &:first-child {
    margin-left: 2.5rem;
    font-size: 14px;
  }
  &:nth-child(5) {
    font-weight: 700;
    justify-content: end;
  }
`;

export const ChangeBlock = styled.div<{ isNegative: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 40px;
  height: 18px;
  border: ${({ isNegative }) => (isNegative ? '1px solid #E47272' : '1px solid #419d88')};
  background-color: ${({ isNegative }) =>
    isNegative ? 'rgba(228, 114, 114, 0.2)' : 'rgba(10, 175, 137, 0.2)'};
  color: ${({ isNegative }) => (isNegative ? '1px solid #E47272' : '1px solid #419d88')};
`;
